import script from "./FamilyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyPage.vue?vue&type=script&setup=true&lang=js"

import "./FamilyPage.vue?vue&type=style&index=0&id=62715987&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62715987"]])

export default __exports__